"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { referenceErreur } from "@/lib/erreur";

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  // Un numéro à l'écran, le détail en console (26/10, Zidan — lib/erreur.ts).
  const ref = referenceErreur(error);
  useEffect(() => {
    Sentry.captureException(error);
    console.error(`[ogryn] global-error n° ${ref}:`, error.message, '\n', error.stack);
  }, [error, ref]);

  // Styles en ligne : cet écran REMPLACE la mise en page racine, la feuille
  // Tailwind n'y est pas garantie.
  return (
    <html lang="fr">
      <body style={{ margin: 0, minHeight: '100dvh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, background: '#2D2D2D', color: '#fff', fontFamily: 'system-ui, sans-serif', textAlign: 'center', padding: 24 }}>
        <strong>Cet écran n&apos;a pas pu s&apos;afficher</strong>
        <span style={{ opacity: .5, fontSize: 14 }}>Erreur n° {ref}</span>
        <button type="button" onClick={() => window.location.reload()}
          style={{ padding: '10px 16px', borderRadius: 12, border: 0, background: '#10b981', color: '#fff', fontWeight: 700 }}>
          Réessayer
        </button>
      </body>
    </html>
  );
}
